/*eslint-disable*/
import { PlusIcon } from 'assets/icons/PlusIcon'
import RemoveCircle from 'assets/icons/RemoveCircle'
import { CancelBtn } from 'components/Button/CancelBtn'
import { DropZone } from 'components/DropZone/DropZone'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { NavBar } from 'components/NavBar/NavBar'
import { ISelectValue } from 'constants/globalTypes'
import { createFuelTask, importFuelTasks } from 'features/fuelManagement/fuelManagementSlice'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex, H1WithBack, ItemsGrid, PageFooter, PageWrapper, Separator, SquareIcon } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { IFuelTaskState } from 'types/fuelManagement.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { standardFieldValidation, validateDate, validateSelect } from 'utils/validationUtils'
import { addFuelTaskInitialState, fuelInputs } from './fuelData'
import { toast } from 'react-toastify'
import { toLocalDateTime } from 'utils/helpers'
import CalendarInput from 'components/CalendarInput/CalendarInput'

export const AddFuelTask = () => {
    const dispatch = useDispatch<AppDispatch>()
    const [file, setFile] = useState<File>(null)
    const [invalidFields, setInvalidFields] = useState(fuelInputs)
    const navigate = useNavigate()
    const [state, setState] = useState<IFuelTaskState>(addFuelTaskInitialState)

    useFocusFirstInput()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        standardFieldValidation(e, setInvalidFields)
        const { name, value } = e.target
        setState(prev => {
            const copy = { ...prev }
            copy[name] = value
            return copy
        })
    }

    const handleDate = (date: Date, name: string) => {
        validateDate(name, setInvalidFields)
        setState(prev => {
            const copy = { ...prev }
            copy[name] = date
            return copy
        })
    }

    const handleTrip = (e: React.ChangeEvent<HTMLInputElement>, i: number) => {
        // standardFieldValidation(e, setInvalidFields) // TODO
        setState(prev => {
            const copy = { ...prev }
            copy.trips[i] = e.target.value
            return copy
        })
    }

    const handleSelect = (v: ISelectValue, name: string) => {
        validateSelect(v, name, setInvalidFields)
        setState(prev => {
            const copy = { ...prev }
            if (name == 'breakdownType') {
                copy.breakdownType = v
            } else {
                copy.machineId = v.value
            }
            return copy
        })
    }

    const handleSubmit = async () => {
        if (!file && invalidFields.length > 0) {
            toast.warn('All fields are required')
            return
        }
        const resp = file ? await dispatch(importFuelTasks(file)) : await dispatch(createFuelTask(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate('/fuel-management')
        }
    }

    const parseMachines = (r) => {
        return r.data.map((m) => ({ value: m.id, label: m.name }))
    }

    const addTrip = () => {
        setState(prev => ({ ...prev, trips: [...prev.trips, ''] }))
    }

    const removeTrip = (index: number) => {
        setState(prev => ({ ...prev, trips: prev.trips.filter((_, i) => i !== index) }))
    }

    const options = [
        { value: 1, label: 'Idle' },
        { value: 2, label: 'Breakdown' }
    ]

    return <>
        <NavBar />
        <PageWrapper>
            <H1WithBack title='Add Fuel Task' arrow />
            <Separator />
            <ItemsGrid baseline columns={3}>
                <Input placeholder='Enter name' labelText='Name' value={state.name} onChange={handleChange} type='text' name='name' invalid={invalidFields.includes('name') ? 'true' : ''} />

                <CalendarInput
                    labelText='Start date'
                    name='startDate'
                    onChange={(v) => handleDate(new Date(v), 'startDate')} //TODO resiti ovo sto se ime pise ovako
                    defaultValue={state.startDate ? toLocalDateTime(state.startDate) : null}
                    includeTime
                />
                <CalendarInput
                    labelText='End date'
                    name='endDate'
                    onChange={(v) => handleDate(new Date(v), 'endDate')}
                    defaultValue={state.endDate ? toLocalDateTime(state.endDate) : null}
                    includeTime
                />
                <Input placeholder='Enter location' labelText='Location' value={state.location} onChange={handleChange} type='text' name='location' invalid={invalidFields.includes('location') ? 'true' : ''} />
                <HonestSelectAsyncInput
                    name='machineId'
                    labelText='Machinery'
                    onChange={handleSelect}
                    link='machines'
                    parserFunction={parseMachines}
                    invalid={invalidFields.includes('machineId')}
                />

                <Input placeholder='Enter description' labelText='Description' value={state.description} onChange={handleChange} type='text' name='description' invalid={invalidFields.includes('description') ? 'true' : ''} />
                <HonestSelectInput options={options} labelText='Breakdown' onChange={handleSelect} name='breakdownType' invalid={invalidFields.includes('breakdownType') ? 'true' : ''} />
                <Input placeholder='Enter breakdown details' labelText='Breakdown details' value={state.breakdownDetails} onChange={handleChange} type='text' name='breakdownDetails' />

                <CalendarInput
                    labelText='Breakdown Start'
                    name='breakdownStartDate'
                    onChange={(v) => handleDate(new Date(v), 'breakdownStartDate')}
                    defaultValue={state.breakdownStartDate ? toLocalDateTime(state.breakdownStartDate) : null}
                    includeTime
                />
                <CalendarInput
                    labelText='Breakdown End'
                    name='breakdownEndDate'
                    onChange={(v) => handleDate(new Date(v), 'breakdownEndDate')}
                    defaultValue={state.breakdownEndDate ? toLocalDateTime(state.breakdownEndDate) : null}
                    includeTime
                />

            </ItemsGrid>
            <Flex gap='1rem' center >
                <TitleText weight='bold' >Trips:</TitleText>
                <SquareIcon onClick={addTrip}  >
                    {PlusIcon}
                </SquareIcon>
            </Flex>
            <ItemsGrid columns={3}>
                {state.trips.map((t, i) => <Flex key={i} center gap='1rem' >
                    <Input placeholder='Enter trip' labelText={'Trip ' + (i + 1)} value={t} onChange={e => handleTrip(e, i)} type='text' name='trip' />
                    <CursorPointer onClick={() => removeTrip(i)} >
                        <RemoveCircle />
                    </CursorPointer>
                </Flex>)}
            </ItemsGrid>
            <BodyText style={{ marginTop: 30 }} >Import from file</BodyText>
            <DropZone file={file} setFile={setFile} />
        </PageWrapper>
        <PageFooter>
            <Flex gap='1rem'>
                <CancelBtn />
                <Button orange onClick={handleSubmit}>
                    {file ? 'Import' : 'Save'}
                </Button>
            </Flex>
        </PageFooter>
    </>
}